import React from "react";
import { Button } from "react-bootstrap";
import "../information&promo.css";

const Promo9 = () => {
  return (
    <div>
      <div
        className="promo-explanation  nunito fade-in2"
        style={{ color: "white" }}
      >
        <h2 className="roleway">PROMO D⚡SAMBER JANUARI </h2>

        <div className="promo-detail-list">
          <h3>Gold Coating</h3>
          <ul>
            <li>2 Layer Coating</li>
            <li>Step one: Compound</li>
            <li>Step two: Polish</li>
            <li>Step three: Finish</li>
            <li>Vacum interior</li>
            <li>Cleaning Doortrim</li>
            <li>Cleaning Dashboard</li>
            <li>Cleaning Roof</li>
            <li>Cleaning Removing Seat and carpet</li>
            <li>Cleaning Velg</li>
          </ul>
        </div>
        <Button
          variant="none"
          target="_blank"
          rel="noreferrer"
          className="price-card-button"
          href={
            "https://api.whatsapp.com/send?phone=+6281399333280&text=Hallo%20saya%20tertarik%20untuk%20melakukan%20booking%20untuk%20Promo%20PROMO%20D⚡SAMBER%20JANUARI%20Gold%20Coating%20waktu%3A%20.....%20Hari%3A%20.....%20Terima%20kasih%20%21"
          }
        >
          Book Now
        </Button>
      </div>
    </div>
  );
};

export default Promo9;
